/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import parse from "html-react-parser";

import "../../css/event220916_2.css";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
import moment from "moment";
// import { isMobile } from "react-device-detect";
//import $ from 'jquery';
//import ReactPlayer from 'react-player'

class Event202210_iba extends Component {
  _seat = () => {
    // const { loginId } = this.props;
    window.open(
      "https://www.aniplustv.com/seat/popSeat.asp",
      "popSeatSetting",
      "width=1018, height=900, scrollbars=yes"
    );
    console.log("좌석");
  };
  _ticket = () => {
    const { loginId, history } = this.props;

    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");
    if (loginId === null || loginId === undefined || loginId === "") {
      //alert('로그인 후 이용해 주세요')
      history.push("/login");
    } else {
      if (
        loginId === "admin" ||
        loginId === "aniplus" ||
        loginId === "kormim" ||
        loginId === "youllk" ||
        loginId === "ani486" ||
        loginId === "goodguyk" ||
        loginId === "hne3456" ||
        loginId === "gtdevil" ||
        loginId === "mwhyung" ||
        loginId === "yurik12" ||
        loginId === "serikasakura" ||
        loginId === "thekk" ||
        loginId === "esshin10" ||
        loginId === "ldhy78" ||
        loginId === "wjrtmab0330" ||
        loginId === "caster3277" ||
        loginId === "cyzel" ||
        loginId === "cyzel" ||
        loginId === "badguyson" ||
        loginId === "aji311"
      ) {
        //alert('10월 12일 오전 11시에 티켓 판매가 시작됩니다.')
        window.open("https://www.aniplustv.com/seat/seat.asp", "seat", "");
      } else {
        if (today >= "2022-10-12 11:00:00" && today <= "2022-10-18 17:00:00") {
          window.open("https://www.aniplustv.com/seat/seat.asp", "seat", "");
          //alert('10월 12일 오전 11시에 티켓 판매가 시작됩니다.')
        } else {
          //window.open("https://www.aniplustv.com/seat/seat.asp", "seat", "")
          alert("10월 12일 오전 11시에 티켓 판매가 시작됩니다.");
        }
      }
    }
  };
  _info = () => {
    const { loginId, history } = this.props;
    if (loginId === null || loginId === undefined || loginId === "") {
      history.push("/login");
      //alert('로그인 후 이용해 주세요')
    } else {
      window.open(
        "https://bill1.aniplustv.com/seat/ticketBuyList_new.asp",
        "popCancel",
        "width=795, height=510, scrollbars=no"
      );
    }
  };
  render() {
    return (
      <Fragment>
        <div className="event_head">
          <h3>아이바 아이나 특별 팬미팅</h3>
          <button type="button" className="btnClose">
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220916_2">
            <div className="btm_bar">
              <ul className="bar">
                <li>
                  <a style={{ cursor: "pointer" }} onClick={this._seat}>
                    <img
                      src="/img/event/event220916_2/bar_btn01.png"
                      alt="극장 좌석표"
                      className="img_web"
                    />
                  </a>
                  <a style={{ cursor: "pointer" }} onClick={this._seat}>
                    <img
                      src="/img/event/event220916_2/m_bar_btn01.png"
                      alt="극장 좌석표"
                      className="img_m"
                    />
                  </a>
                </li>
                <li>
                  <a style={{ cursor: "pointer" }} onClick={this._ticket}>
                    <img
                      src="/img/event/event220916_2/bar_btn02.png"
                      alt="예매하기"
                      className="img_web"
                    />
                  </a>
                  <a style={{ cursor: "pointer" }} onClick={this._ticket}>
                    <img
                      src="/img/event/event220916_2/m_bar_btn02.png"
                      alt="예매하기"
                      className="img_m"
                    />
                  </a>
                </li>
                <li>
                  <a style={{ cursor: "pointer" }} onClick={this._info}>
                    <img
                      src="/img/event/event220916_2/bar_btn03.png"
                      alt="나의 예매정보"
                      className="img_web"
                    />
                  </a>
                  <a style={{ cursor: "pointer" }} onClick={this._info}>
                    <img
                      src="/img/event/event220916_2/m_bar_btn03.png"
                      alt="나의 예매정보"
                      className="img_m"
                    />
                  </a>
                </li>
              </ul>
            </div>

            <section className="section">
              <img
                src="/img/event/event220916_2/event_img1.png"
                alt="팬미팅&전달회"
                className="img_web"
              />
              <img
                src="/img/event/event220916_2/event_img2.png"
                alt="주의사항"
                className="img_web"
              />
              <img
                src="/img/event/event220916_2/m_event_img1.png"
                alt="포스터"
                className="img_m"
              />
              <img
                src="/img/event/event220916_2/m_event_img2.png"
                alt="팬미팅&전달회"
                className="img_m"
              />
              <img
                src="/img/event/event220916_2/m_event_img3.png"
                alt="주의사항"
                className="img_m"
              />
            </section>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202210_iba));
